import {APP_INITIALIZER, ApplicationConfig, inject, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {initializeApp, provideFirebaseApp} from '@angular/fire/app';
import {Auth, getAuth, provideAuth, authState, User} from '@angular/fire/auth';
import {getAnalytics, provideAnalytics, ScreenTrackingService, UserTrackingService} from '@angular/fire/analytics';
import {getFirestore, provideFirestore} from '@angular/fire/firestore';
import {getMessaging, provideMessaging} from '@angular/fire/messaging';
import {getStorage, provideStorage} from '@angular/fire/storage';
import {getRemoteConfig, provideRemoteConfig} from '@angular/fire/remote-config';
import {MatIconRegistry} from '@angular/material/icon';
import {authInterceptor, errorInterceptor} from './http-interceptor';
import {environment} from '../environments/environment';
import {provideEnvironmentNgxMask} from 'ngx-mask';
import {provideQuillConfig} from 'ngx-quill';
import {providePostHogErrorHandler} from './posthog-error-handler';
import {OrganizationService} from './services/organization.service';
import {take} from 'rxjs';
import {jwtDecode} from 'jwt-decode';

export const appConfig: ApplicationConfig = {
  providers: [provideEnvironmentNgxMask(), provideZoneChangeDetection({eventCoalescing: true}), provideRouter(routes), provideAnimationsAsync(), provideHttpClient(
    withInterceptors([authInterceptor, errorInterceptor])
  ), provideFirebaseApp(() => initializeApp(environment.firebaseConfig)), provideAuth(() => getAuth()), provideAnalytics(() => getAnalytics()), ScreenTrackingService, UserTrackingService, provideFirestore(() => getFirestore()), provideMessaging(() => getMessaging()), provideStorage(() => getStorage()), provideRemoteConfig(() => getRemoteConfig()),
    provideQuillConfig({
      modules: {
        syntax: false,
        toolbar: [
          ['bold', 'italic',],[ 'underline', 'strike'], [{ 'color': [] }, { 'background': [] }],  [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        ]
      }
    }),
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: (iconRegistry: MatIconRegistry) => () => {
        const defaultFontSetClasses = iconRegistry.getDefaultFontSetClass();
        const outlinedFontSetClasses = defaultFontSetClasses
          .filter((fontSetClass) => fontSetClass !== 'material-icons')
          .concat(['material-symbols-outlined']);
        iconRegistry.setDefaultFontSetClass(...outlinedFontSetClasses);
      },
      deps: [MatIconRegistry]
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: () => {
        const auth = inject(Auth);
        const organizationService = inject(OrganizationService);
        return () => new Promise<void>((resolve) => {
          const impersonatingUserOrgId = localStorage.getItem('impersonatingUserOrgId');
          if (impersonatingUserOrgId) {
            organizationService.currentOrganizationId = impersonatingUserOrgId;
            resolve();
            return;
          }
          if (localStorage.getItem('impersonatingOrgId')) {
            resolve();
            return;
          }
          authState(auth).pipe(take(1)).subscribe({
            next: async (user: User | null) => {
              if (user) {
                try {
                  const token = await user.getIdToken();
                  const decoded: any = jwtDecode(token);
                  const orgId = Array.isArray(decoded.organizations)
                    ? decoded.organizations[0]
                    : decoded.organizations;
                  if (orgId) {
                    organizationService.currentOrganizationId = orgId;
                  }
                } catch (e) {
                  console.error('Failed to initialize organization from token:', e);
                }
              }
              resolve();
            },
            error: () => resolve()
          });
        });
      }
    },
    providePostHogErrorHandler(),
  ]
};

// {
//   provide: APP_INITIALIZER,
//     multi: true,
//   useFactory: (iconRegistry: MatIconRegistry) => () => {
//   const defaultFontSetClasses = iconRegistry.getDefaultFontSetClass();
//   const outlinedFontSetClasses = defaultFontSetClasses
//     .filter((fontSetClass) => fontSetClass !== 'material-icons')
//     .concat(['material-symbols-outlined']);
//   iconRegistry.setDefaultFontSetClass(...outlinedFontSetClasses);
// },
//   deps: [MatIconRegistry]
// }
